import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    notification:[],
}

const notificationSlice = createSlice({
  name: "Notification",
  initialState: initialState,
  reducers: {
    setNotification(state, value) {
      state.notification = value.payload;
    }
  },
});

export const { setNotification} = notificationSlice.actions;

export default notificationSlice.reducer;